




















import Vue from "vue";
import Component from "vue-class-component";
import ContactTable from "../../components/admin/ContactTable.vue";

@Component({ components: { ContactTable } })
export default class Contacts extends Vue {
  selected: "contact-us" | "billboard" = "contact-us";
  onChange(key: number) {
    switch (key) {
      case 1:
        this.selected = "billboard";
        break;
      default:
        this.selected = "contact-us";
    }
  }
}
